import {Component, ElementRef} from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { Observable, Subscription } from "rxjs";

import { Host, AppService } from "../../../common";
import { Cart, CartService } from "../../../common";
import { BackendService } from "../../../common";
import { Color } from '../util/color';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html'
})

export class AppComponent {

  title = 't4dng';
  host: Host = null;
  cart: Cart = null;
  idtag: string = null;
  backend: string = '';
  theme: string = 'classic.css';
  loading: Observable<boolean>;
  in_frame: boolean = false;

  subscription: Subscription = null;

  constructor(
    private appService: AppService,
    private backendService: BackendService,
    private cartService: CartService,
    private route: ActivatedRoute,
    private domRef: ElementRef,
  ) {}


  ngOnInit() {
    this.subscription = this.appService.load().subscribe(({host, menu, table, cart}) => {
      if (host) {
        this.host = host;
        this.idtag = table.idtag;
        this.cart = cart;
      } else {
        this.idtag = '';
      }
      this.loading = this.appService.getLoading();
    });

    const dataset = this.domRef.nativeElement.dataset;

    // configure the UrlService. Our backend can be supplied as data-attribute.
    // If not set there, assume we are served from the same host as the backend
    // (e.g. from Django)
    if (dataset.hasOwnProperty('backend')) {
      this.backend = dataset['backend'];
    } else {
      this.backend = window.location.protocol + '//' + window.location.host + '/data/';
    }
    this.backendService.setBackend(this.backend);
    if (dataset.hasOwnProperty('assetBase')) {
      this.backendService.setAssetBase(dataset.assetBase);
    }

    // idtag can be supplied as data-attribute. In that case,
    // start right away. Otherwise, we show the idtag entry dialog.
    if (dataset.hasOwnProperty('idtag')) {
      this.idtag = dataset['idtag'];
      this.appService.setTable(this.idtag);
    }

    // show_only mode can be supplied as data-attribute, set it at
    // AppService because there we have getOrdersEnabled()
    if (dataset.hasOwnProperty('showOnly')) {
      // document.querySelector('body').classList.add('is-show-only');
      this.appService.showOnly = true;
    }
    console.log("showOnly", this.appService.showOnly);

    if (dataset.hasOwnProperty('demo')) {
      document.querySelector('body').classList.add('is-demo');
      this.cartService.isDemo = true;
    }

    this.in_frame = this.appService.in_frame;

    // get theme
    this.theme = (dataset.hasOwnProperty('theme') ? dataset['theme']: 'classic.css');

    // add handler to close ourselves when body is clicked (desktop mode)
    if (this.appService.in_frame) {
      document.body.addEventListener('click', (e) => {
        if (e.target == document.body)
          this.appService.closeApp();
        return false;
      })
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setTag(tag: string): void {
    this.appService.setTable(tag);
  }

  canClose() {
    return this.appService.canClose();
  }
}
